import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { TotalOrderAmount } from 'src/constrains/AdvancedFilters/Components';
import { EType } from 'src/constrains/AdvancedFilters/Components/CommonAmount';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const Item = Form.Item;
// // import { get } from 'lodash';
//import { formGetValue } from 'src/tools/helper';

const _TotalOrderAmount = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    rootName,
    form,
    defaultState,
    nameType,
    nameValue,
    nameRange,
    currency,
    ...rest
  } = props;
  const handleOnReset = () => {
    form.setFieldsValue(defaultState);
  };
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(rootName);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const prefix = {
          [EType.EQUALS]: getI18n('customerList.totalOrderAmount.eType.EQUALS'),
          [EType.IN_BETWEEN]: getI18n(
            'customerList.totalOrderAmount.eType.IN_BETWEEN',
          ),
          [EType.LARGER_THAN]: getI18n(
            'customerList.totalOrderAmount.eType.LARGER_THAN',
          ),
          [EType.SMALLER_THAN]: getI18n(
            'customerList.totalOrderAmount.eType.SMALLER_THAN',
          ),
        };
        const type = getFieldValue(nameType);
        const handleOnClose = () => {
          form
            .validateFields([nameType, nameValue, nameRange])
            .then(() => {
              //console.log('没错');
            })
            .catch((r) => {
              handleOnReset();
            });
        };
        const textGenerator = () => {
          if (hasData) {
            if (type === EType.IN_BETWEEN) {
              const value = getFieldValue(nameRange);
              const from = value.from;
              const to = value.to;
              if (typeof from === 'number' && typeof to === 'number') {
                return replaceI18nVariables(
                  getI18n(`customerList.totalOrderAmount.ordernumberand`),
                  `${prefix[type]} ${from.toFixed(2)}`,
                  `${to.toFixed(2)} ${currency}`,
                );
              }
            } else {
              const value = getFieldValue(nameValue);
              if (typeof value === 'number') {
                return `${getI18n(
                  'customerList.totalOrderAmount.ordernumber',
                )} ${prefix[type]} ${value.toFixed(2)} ${currency}`;
              }
            }
          }
          return '';
        };

        const hasData = !!type;
        return (
          <Co
            header={
              <div>
                {getI18n('customerList.totalOrderAmount.totalorderamount')}
              </div>
            }
            displayText={textGenerator()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={handleOnReset}>
            <TotalOrderAmount
              {...rest}
              suffix={currency}
              nameValue={nameValue}
              nameRange={nameRange}
              nameType={nameType}
            />
          </Co>
        );
      }}
    </Item>
  );
};
export default _TotalOrderAmount;
